export const version = 'kunde-v1.20.0-SNAPSHOT-30e75a5e7b121395841f1bcfe7326d35c1d82294';